<template>
    <v-dialog persistent v-model="dialog" width=50%>
        <v-card class="px-2">
            <v-container>
                
                <div class="row-pointer">
                    <v-row class="pa-4" style="align-items: center;">
                        <h3>Update complaint event</h3>
                        <span class="ml-4" style="color: #1976d2; background-color: rgba(25, 118, 210, 0.1); border: 1px solid #1976d2; border-radius: 8px; padding: 4px 10px; display: inline-flex; align-items: center;">
                            <v-icon color="#1976d2" size="18" class="mr-2">mdi-information</v-icon>{{ claim_description }}
                        </span>
                    </v-row>
                    <v-row><v-divider></v-divider></v-row>
                    <v-row dense class="pl-4 mt-6">
                        <v-col cols="4">Registered by</v-col>
                        <v-col cols="4">{{ hsmr_gebr }}</v-col>
                    </v-row>
                    <v-row dense class="pl-4 mt-0">
                        <v-col cols="4">Registration date/time</v-col>
                        <v-col cols="4">{{ $moment(hsmr_date_time).format("DD-MM-YYYY HH:mm") }}</v-col>
                    </v-row>
                    <v-row><v-divider></v-divider></v-row>
                </div>

                <v-row dense class="pl-4 mt-8">
                    <v-col cols="4">
                        <status_selector :selected_eventstatus="hsmr_smst" label="Status" field="hsmr_smst"
                            @updateData="updateData" :disabled="isClosed" />
                    </v-col>
                </v-row>

                <v-row no-gutters class="mx-5">
                    <v-col cols=12>
                        <v-form v-model="hsmr_valid">
                            <v-textarea v-model="hsmr_text" rows="4" required label="Damage event text"
                                :rules="descriptionRules">{{ hsmr_text }}</v-textarea>
                        </v-form>
                    </v-col>
                </v-row>

                <v-card fluid flat class="mt-0 pl-4 mb-4 pr-6">
                    <hokl_hosm_links :links="links" @updateData="updateData" />
                </v-card>

                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" small :disabled="!hsmr_valid" v-on:click="saveHsmr()">Save</v-btn>
                    <v-btn color="primary" small v-on:click="dialog = false">Close</v-btn>
                </v-card-actions>

            </v-container>
        </v-card>
    </v-dialog>
</template>

<style scoped>
.row-pointer {
    cursor: default;
}
</style>

<script>

import status_selector from '@/components/huov/hosm/ui/status_selector.vue';
import hokl_hosm_links from '@/components/huov/ui/hokl_hosm_links.vue';

export default {

    props: {
        claim_description: String
    },
    data() {
        return {
            dialog: false,
            hsmr_encrid: null,
            hsmr_valid: false,
            hsmr_date_time: null,
            hsmr_text: '',
            hsmr_smst: '',
            hsmr_gebr: '',
            links: [],
            descriptionRules: [
                v => !!v || "A description / value is required"
            ],
            isClosed: false
        }
    },
    components: {
        status_selector,
        hokl_hosm_links,
    },

    methods: {
        open(hsmr_encrid) {
            this.dialog = true;
            this.hsmr_encrid = hsmr_encrid;
            this.links = [];
            this.getSingleHsmr(hsmr_encrid);
            this.isClosed = false;
        },
        updateData(data) {
            console.log('updateData', data);
            this[data.field] = data.value;
        },
        getSingleHsmr() {
            this.$axios
                .post("ares/json/ares/huov/hosm/getSingleHsmr.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getSingleHsmr"
                    },
                    getSingleHsmr: {
                        hsmr_encrid: this.hsmr_encrid
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.hsmr_text = res.data.hsmr.hsmr_oms;
                        this.hsmr_smst = res.data.hsmr.hsmr_smst;
                        this.hsmr_gebr = res.data.hsmr.gebr_naam;
                        this.hsmr_date_time = res.data.hsmr.hsmr_dt;
                        this.links = res.data.hsmr.links;
                        this.isClosed = this.hsmr_smst === 'closed';
                    }
                });
        },
        saveHsmr() {
            this.$axios
                .post("ares/json/ares/huov/hosm/updHsmrv2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updHsmr"
                    },
                    updHsmr: {
                        hsmr_encrid: this.hsmr_encrid,
                        hsmr_text: this.hsmr_text,
                        hsmr_smst: this.hsmr_smst,
                        links: this.links,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.$emit('updateData', 'refresh');
                        this.dialog = false; // close dialog + update
                    }
                });
        }

    }
}
</script>

